// App Store
import { app } from './utils/store';

// User Detect
import { DetectionManager, Credits } from './utils/detect';

// Navigation
import { Navigation, Footer } from './modules/Navigation';

// Classes::Managers
import { ScrollManager } from './classes/Scroll';
import Form from './classes/Forms';

// AsyncLoad
import AsyncLoad from './classes/AsyncLoad';

// Module
// Import your own modules

// Pages
// Import your own pages
import Home from './Pages/Home';

class App {
    constructor() {
        app.init = true;
        app.root = document.body;
        app.viewport = document.querySelector('[data-app-viewport]');
        app.content = document.getElementById('app-content');

        //Async Load
        this.images = document.querySelectorAll('[data-src][data-webp]');
        this.preloaders = this.images.forEach((image) => {
            return new AsyncLoad({ element: image });
        });

        this.createContent();

        this.createNavigation();

        this.createPages();

        this.createScroll();
        this.createForms();
        this.advAccordion();

        app.loading = false;
        app.root.style.setProperty('--viewport-height', `${window.visualViewport.height}px`);

        this.sub_hero = document.getElementById('scroll-hero');
        app.root.style.setProperty('--sub-hero-height', `${this.sub_hero.offsetHeight}px`);
        this.addEventListeners();

        console.log(app);
    }

    // Create Content
    createContent = () => {
        this.template = app.root.getAttribute('data-template');
        this.content = document.querySelector('[data-app-content]');

        this.wrapper = document.querySelector('[data-wrapper]');

        this.anchors = document.querySelectorAll('a[href*="#"]:not([href="#"])');

        app.current = this.template;
        app.wrapper = this.wrapper;
    };

    // Create Navigation
    createNavigation = () => {
        this.navigation = new Navigation();
        this.footer = new Footer();
    };

    // Create Pages
    createPages = () => {
        this.pages = {
            home: new Home(),
        };

        this.page = this.pages[app.current];
        app.page = this.page;

        app.page.create();
    };

    // Create Scroll
    createScroll = () => {
        if (this.anchors) {
            this.anchors.forEach((link) => ScrollManager.scrollBehaviour(link));
        }
    };

    // Create Forms
    createForms = () => {
        if (this.forms) {
            this.forms.forEach((form) => {
                return new Form({ form });
            });
        }
    };

    advAccordion = () => {
        const labels = document.querySelectorAll('.adv-label');
        const arrows = document.querySelectorAll('.adv-arrow');

        function toggleDescription(element) {
            const description = element.parentNode.querySelector('.adv-description');
            const siblingElement = element.classList.contains('adv-label')
                ? element.nextElementSibling
                : element.previousElementSibling;

            if (element.classList.contains('highlight')) {
                description.classList.remove('active');
                element.classList.remove('highlight');
                if (siblingElement) {
                    siblingElement.classList.remove('highlight');
                }
            } else {
                document.querySelectorAll('.adv-description').forEach((desc) => {
                    desc.classList.remove('active');
                });

                document.querySelectorAll('.adv-label, .adv-arrow').forEach((el) => {
                    el.classList.remove('highlight');
                });

                description.classList.add('active');
                element.classList.add('highlight');
                if (siblingElement) {
                    siblingElement.classList.add('highlight');
                }
            }
        }

        labels.forEach((label) => {
            label.addEventListener('click', function () {
                toggleDescription(this);
            });
        });

        arrows.forEach((arrow) => {
            arrow.addEventListener('click', function () {
                toggleDescription(this);
            });
        });

        const burgerBtns = document.querySelectorAll('.burger-btn');
        const mobileMenu = document.querySelector('.mobile-menu');

        burgerBtns.forEach(function (burgerBtn) {
            burgerBtn.addEventListener('click', function () {
                if (mobileMenu.classList.contains('open')) {
                    mobileMenu.classList.remove('open');
                } else {
                    mobileMenu.classList.add('open');
                }
            });
        });
    };

    addEventListeners() {
        window.visualViewport.addEventListener('resize', () => {
            app.root.style.setProperty('--viewport-height', `${window.visualViewport.height}px`);
            app.root.style.setProperty('--sub-hero-height', `${this.sub_hero.offsetHeight}px`);
        });
    }
}

new App();
new Credits();
